import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import { AsectionsQuestionsListResultLayer } from '../components/SECTION A/AsectionsQuestionsListResultLayer'


export const AsectionsQuestionsResultListPage = () => {
  return (
    <MasterLayout>
        <AsectionsQuestionsListResultLayer />
    </MasterLayout>
  )
}
